import { browser } from "$app/environment"


let defaultcab = {
    exist: false,
    nombre: "",
    id: "",
    latitud: null,
    longitud: null,
}
export function saveStorageEstablecimiento(data) {
    let storageKey = "establecimiento"
    localStorage.setItem(storageKey, JSON.stringify(data));
}
export function saveStorageEstablecimientoDefault() {
    let storageKey = "establecimiento"
    let estdefault = {
        exist: false,
        nombre: "",
        id: "",
    }
    localStorage.setItem(storageKey, JSON.stringify(estdefault));
}
export function loadStorageEstablecimiento() {
    let storageKey = "establecimiento"
    if (browser) {
        const data = localStorage.getItem(storageKey);
        if (data) {
            try {
                const parsedData = JSON.parse(data);

                const mergedData = { ...defaultcab, ...parsedData };

                localStorage.setItem(storageKey, JSON.stringify(mergedData));
                return mergedData;
            } catch (e) {
                console.error("Error parseando", storageKey, e);
                localStorage.setItem(storageKey, JSON.stringify(defaultcab));
                return structuredClone(defaultcab);
            }
        }
        else {
            localStorage.setItem(storageKey, JSON.stringify(defaultcab));
            return structuredClone(defaultcab);
        }


    }
    else {
        return structuredClone(defaultObj);
    }
}
// `saveStoragePermiso` / `loadStoragePermiso` se borraron el 2026-08-16 junto con
// las tablas de planes hardcodeadas del front. Guardaban en localStorage un
// string "maxAnimals,maxEstablishments,maxUsers" derivado de esas tablas: se
// escribía desde 8 lugares y NO se leía desde ninguno — `loadStoragePermiso` no
// tenía un solo call-site (y estaba rota, además: mergeaba contra `defaultcab` y
// devolvía un `defaultObj` inexistente). Era el resto del chequeo de cupo en el
// cliente. Los topes los aplica el backend.